import React, { Component } from 'react';
import * as d3 from 'd3';
import numeral from 'numeral';
import * as annotation from 'd3-svg-annotation';

import { Button, TextField, Switch } from 'react-md'

class OptionPoolDataViz extends Component {
  
  componentDidMount() {
    var optionPoolData = {
      founderStockIssued: 6000000,
      investorStockIssued: 2000000,
      optionPoolSize: 2000000,
      unissuedOptionPoolStock: 1500000
    }

    var chartData;

    function generateChartData(optionPoolData){
      var fullyDilutedCapVC = parseInt(optionPoolData.founderStockIssued, 10) + parseInt(optionPoolData.investorStockIssued, 10) + parseInt(optionPoolData.optionPoolSize, 10);
      var fullyDilutedCapAcq = parseInt(optionPoolData.founderStockIssued, 10) + parseInt(optionPoolData.investorStockIssued, 10) + parseInt(optionPoolData.optionPoolSize, 10) - parseInt(optionPoolData.unissuedOptionPoolStock, 10);

      chartData = [
        {
          //TODO: prettify with numeral
          //TODO: error handling if unissued options > option pool size
          founders: (optionPoolData.founderStockIssued / fullyDilutedCapVC) * 100,
          investors: (optionPoolData.investorStockIssued / fullyDilutedCapVC) * 100,
          issuedOptions: ((optionPoolData.optionPoolSize - optionPoolData.unissuedOptionPoolStock) / fullyDilutedCapVC) * 100,
          unissuedOptions: (optionPoolData.unissuedOptionPoolStock / fullyDilutedCapVC) * 100
        },
        {
          founders: (optionPoolData.founderStockIssued / fullyDilutedCapAcq) * 100,
          investors: (optionPoolData.investorStockIssued / fullyDilutedCapAcq) * 100,
          issuedOptions: ((optionPoolData.optionPoolSize - optionPoolData.unissuedOptionPoolStock) / fullyDilutedCapAcq) * 100,
          unissuedOptions: 0
        }
      ]
    }

    generateChartData(optionPoolData);

    var margin = {top: 30, right: 150, bottom: 25, left: 120},
        width = 700 - margin.left - margin.right,
        height = 300 - margin.top - margin.bottom,
        animationDuration = 1000,
        layers

    var color = d3.scaleOrdinal(d3.schemeCategory10);

    var xDomain = ["Series A", "Company Acquired"];
    var keys = ["Founders", "Investors", "Issued Stock Options", "Unissued Stock Options"];
    var dataKey = ['founders', 'investors', 'issuedOptions', 'unissuedOptions'];

    var stack = d3.stack()
          .keys(dataKey)

    var series = stack(chartData);
    //Adding keys to each datapoint
    series.forEach(function(d, i){
      d.forEach(function(dd, j){
        dd.stockType = dataKey[i];
      })
    })
    //- console.log(series);
    var newSeries;

    var groupToggle = document.querySelector('#group-toggle');
    groupToggle.addEventListener('click', toggle);

    var x = d3.scaleBand()
      .domain(xDomain)
      .rangeRound([0, width]);

    var y = d3.scaleLinear()
      .domain([0,100])
      .range([height, 0]);

    var z = d3.scaleBand()
      .domain(dataKey)
      .rangeRound([0, x.bandwidth()]);

    var svg = d3.select('#option-pool-chart').append('svg')
      .attr('viewBox', '0 0 700 300')
      .attr("preserveAspectRatio", "xMidYMid meet")
      .attr("class", "option-pool-svg")
      .append('g')
      .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

    var xAxis = d3.axisBottom(x)

    var yAxis = d3.axisLeft(y)
      .tickFormat(function(d) { return d + "%"; });

    function animateStackedBars(selection) {
      selection.transition()
        .duration(animationDuration)
        .attr("y", function(d) {
          return y(d[1]);
        })
        .attr("height", function(d){
          return y(d[0]) - y(d[1]);
        });
    };

    function animateGroupedBars(selection) {
      selection.transition()
        .duration(animationDuration)
        .attr("y", function(d) {
            return y(d.data[d.stockType]);
        })
        .attr("height", function(d){
          return y(d[0]) - y(d[1]);
        });
    };

    y.domain([0, 100]);

    layers = svg.selectAll('.layer')
      .data(series)
    .enter().append('g')
      .attr("class", function(d){
        return d.key;
      })
      .style('fill', function(d,i){ return color(i); })

    layers.selectAll("rect")
      .data(function(d) {
        return d;
      })
    .enter().append("rect")
      .attr("x", function(d, i) {
        return x(xDomain[i]) + 10;
      })
      .attr("width", x.bandwidth() - 20)
      .attr("y", function(d) {
        return y(d[1]);
      })
      .attr("height", function(d){
        return y(d[0]) - y(d[1]);
      })
      .on("mouseover", mouseover)
      .on("mousemove", mousemove)
      .on("mouseout", mouseout)

    svg.append('g')
      .attr("class", "y axis")
      .call(yAxis)

    svg.append('g')
      .attr("class", "x axis")
      .attr("transform", "translate(0," + height + ")")
      .call(xAxis)

    svg.append('text')
      .attr("x", (width / 2))
      .attr("y", 0 - (margin.top / 2))
      .attr("text-anchor", "middle")
      .style("font-size", "14px")
      .text("Stock Ownership re: Option Pool")

    var legend = svg.append('g')
      .attr("class", "legend")
      .selectAll('g')
    .data(keys)
      .enter().append('g')
      .attr("transform", function(d,i){
        return "translate(0," + i * 20 + ")"
    });

    legend.append('rect')
      .attr("x", width)
      .attr("width", 19)
      .attr("height", 19)
      .attr("fill", function(d,i){ return color(i) });

    legend.append('text')
      .attr("x", width + 24)
      .attr("y", 9.5)
      .attr("dy", "0.35em")
      .attr("font-size", "10px")
      .text(function(d){
        return d;
      });

    var div = d3.select("#option-pool-chart").append("div")
      .attr("class", "tooltip")
      .style("display", "none");

    function updateOptionPoolData(){
      optionPoolData.founderStockIssued = document.querySelector('#common-stock-founders-input').value;
      optionPoolData.investorStockIssued = document.querySelector('#preferred-stock-investors-input').value;
      optionPoolData.optionPoolSize = document.querySelector('#option-pool-input').value;
      optionPoolData.unissuedOptionPoolStock = document.querySelector('#unissued-option-pool-input').value;
    }

    function redraw(){
      updateOptionPoolData();
      document.querySelector('#options-fully-diluted-capitalization').innerHTML = ' ' + numeral(parseInt(optionPoolData.founderStockIssued, 10) + parseInt(optionPoolData.investorStockIssued, 10) + parseInt(optionPoolData.optionPoolSize, 10)).format(0,0)
      generateChartData(optionPoolData);
      newSeries = stack(chartData);
      newSeries.forEach(function(d, i){
        d.forEach(function(dd, j){
          dd.stockType = dataKey[i];
        })
      })
      layers = layers.data(newSeries);

      if(groupToggle.checked === false){
        layers.selectAll('rect')
          .data(function(d){
            return d;
          })
          .call(animateStackedBars);

        d3.select(".stacked-annotation").transition().style("opacity", 0)
          .on("end", function() {
            updateStackedAnnotationsData();
            makeStackedAnnotations.update();
            updateGroupedAnnotationsData();
            makeGroupedAnnotations.update();
            d3.select(".stacked-annotation").transition().style("opacity", 1);
          });
      } else {
        layers.selectAll('rect')
          .data(function(d){
            return d;
          })
          .call(animateGroupedBars);

        d3.select(".grouped-annotation").transition().style("opacity", 0)
          .on("end", function() {
            updateStackedAnnotationsData();
            makeStackedAnnotations.update();
            updateGroupedAnnotationsData();
            makeGroupedAnnotations.update();
            d3.select(".grouped-annotation").transition().style("opacity", 1);
          });
      }
      
    }

    // d3-annotations
    const type = annotation.annotationCalloutRect

    // Annotations for stacked bar chart
    var stackedAnnotations = [{
      note: {
        label: parseInt(optionPoolData.optionPoolSize, 10) / (parseInt(optionPoolData.founderStockIssued, 10) + parseInt(optionPoolData.investorStockIssued, 10) + parseInt(optionPoolData.optionPoolSize, 10)) * 100 + "%",
        title: "Stock Reserved in Option Pool",
        wrap: 80
      },
      x: x("Series A") + 130,
      y: margin.top,
      dy: 40,
      dx: -50,
      subject: {
        width: x.bandwidth() - 20,
        height: y(100 - chartData[0].issuedOptions - chartData[0].unissuedOptions)
      }
    }]

    const updateStackedAnnotationsData = () => {
      stackedAnnotations[0].y = margin.top;
      stackedAnnotations[0].subject.height = y(100 - chartData[0].issuedOptions - chartData[0].unissuedOptions);
      stackedAnnotations[0].note.label = numeral(parseInt(optionPoolData.optionPoolSize, 10) / (parseInt(optionPoolData.founderStockIssued, 10) + parseInt(optionPoolData.investorStockIssued, 10) + parseInt(optionPoolData.optionPoolSize, 10)) * 100).format('0.0') + "%";

      makeStackedAnnotations.annotations(stackedAnnotations);
    }

    const makeStackedAnnotations = annotation.annotation()
      .type(type)
      .annotations(stackedAnnotations)

    d3.select(".option-pool-svg")
      .append("g")
      .attr("class", "annotation-group stacked-annotation")
      .call(makeStackedAnnotations)

    // Annotations for grouped bar chart
    var groupedAnnotations = [{
      note: {
        label: numeral(chartData[1].investors - chartData[0].investors).format('0.0') + "%",
        title: "Additional Equity Given to Investors from Unissued Options",
        wrap: 115
      },
      x: x("Company Acquired") + margin.left + z("investors"),
      y: y(chartData[1].investors) + margin.top,
      dy: (height - y(chartData[1].investors - chartData[0].investors)) - 30,
      dx: 165,
      subject: {
        width: x.bandwidth() / dataKey.length,
        height: height - y(chartData[1].investors - chartData[0].investors)
      }
    }]

    const updateGroupedAnnotationsData = () => {
      groupedAnnotations[0].y = y(chartData[1].investors) + margin.top;
      groupedAnnotations[0].subject.height = height - y(chartData[1].investors - chartData[0].investors);
      groupedAnnotations[0].note.label = numeral(chartData[1].investors - chartData[0].investors).format('0.0') + "%";

      makeGroupedAnnotations.annotations(groupedAnnotations);
    }

    const makeGroupedAnnotations = annotation.annotation()
      .type(type)
      .annotations(groupedAnnotations)

    d3.select(".option-pool-svg")
      .append("g")
      .attr("class", "annotation-group grouped-annotation")
      .style("opacity", 0)
      .call(makeGroupedAnnotations)
      
    var updateButton = document.querySelector('#update-options-pool');
    updateButton.addEventListener('click', redraw);

    function upperCaseFirst(string){
      return string.charAt(0).toUpperCase() + string.slice(1);
    }

    function mouseover() {
      div.style("display", "inline");
      d3.select(this)
        .style("opacity", 0.7);
    }

    function mousemove(d) {
      var key = d3.select(this.parentNode).attr("class").replace(/([A-Z])/g, ' $1').trim();
      var percent = d[1] - d[0];
      div
        .html(upperCaseFirst(key) + ':<br><br>' + numeral(percent).format('0.0') + '%')
        .style("left", (d3.event.pageX) + "px")
        .style("top", (d3.event.pageY - 400) + "px");
    }

    function mouseout() {
      div.style("display", "none");
      d3.select(this)
        .style("opacity", 1);
    }

    function transitionGrouped(){
      layers.selectAll('rect').transition()
        .duration(500)
        .attr("x", function(d, i) {
                    return x(xDomain[i]) + z(d.stockType);
                })
        .attr("width", x.bandwidth() / dataKey.length)
      .transition()
        .attr("y", function(d) {
            return y(d.data[d.stockType]);
        })
        .attr("height", function(d, i) {
            return height - y(d.data[d.stockType]);
        })
        .on("end", function(){
          d3.select(".grouped-annotation").transition()
            .duration(500)
            .style("opacity", 1);
        })
      
      d3.select(".stacked-annotation").transition().style("opacity", 0);
    }

    function transitionStacked(){
      d3.select(".grouped-annotation").transition()
        .duration(500)
        .style("opacity", 0)
        .on("end", function(){
          layers.selectAll('rect').transition()
            .duration(500)
            .attr("y", function(d) {
              return y(d[1]);
            })
            .attr("height", function(d) {
                return y(d[0]) - y(d[1]);
            })
          .transition()
            .attr("x", function(d, i) {
              return x(xDomain[i]) + 10;
            })
            .attr("width", x.bandwidth() - 20)
            .on("end", function(){
              d3.select(".stacked-annotation").transition()
                .duration(500)
                .style("opacity", 1);
            })
        })
    }

    function toggle(){
      if (this.checked === true){
        transitionGrouped();
      } else {
        transitionStacked();
      }
    }
  }

  shouldComponentUpdate() {
    return false;
  }
  
  render() {
    return (
      <div style={{marginBottom: '2rem'}}>
        <div id="option-pool-chart"></div>
        <Switch id="group-toggle" type="switch" name="option pool chart toggle from stacked bar chart to grouped bar chart" label="Grouped Bar Chart">Grouped Bar Chart</Switch>
        <p><span><b>Fully Diluted Capitalization:</b></span> <span id="options-fully-diluted-capitalization">10,000,000</span> </p>
        <div className="md-grid">
          <TextField 
            label="Stock Issued to Founders" 
            defaultValue={6000000} 
            className="data-viz-input"
            id="common-stock-founders-input"></TextField>

          <TextField 
            label="Stock Issued to Investors" 
            defaultValue={ 2000000} 
            className="data-viz-input"
            id="preferred-stock-investors-input"></TextField>

          <TextField 
            label="Option Pool Size (# of Shares)" 
            defaultValue={ 2000000 } 
            className="data-viz-input"
            id="option-pool-input"></TextField>

          <TextField 
            label="Unissued Stock in Option Pool" 
            defaultValue={ 1500000 } 
            className="data-viz-input"
            id="unissued-option-pool-input"></TextField>
        </div>
        <div>
          <Button id="update-options-pool" raised>UPDATE</Button>
        </div>
      </div>
    )

  }
}

export default OptionPoolDataViz;


// WEBPACK FOOTER //
// ./src/components/OptionPoolDataViz.js